<div *ngIf="!isLoading" [class]="displayStyle">
  <h2 *ngIf="title">{{ title }}</h2>
  <table *ngIf="displayStyle === 'detail'" class="dynamicTable">
    <ng-container *ngFor="let entry of content">
      <tr *ngIf="!entry.link">
        <td>{{ entry.key }}:</td>
        <td *ngIf="!entry.children">{{ entry.content }}</td>
        <td *ngIf="entry.children" [innerHTML]="entry.content"></td>
      </tr>
      <tr *ngIf="entry.link">
        <td>{{ entry.key }}</td>
        <td><a href="{{entry.content}}" target="_blank"><i class="material-icons">link</i>{{ entry.content }}</a></td>
      </tr>
    </ng-container>
  </table>

  <table *ngIf="displayStyle === 'log'" class="dynamicTable">
    <ng-container *ngFor="let entry of content">
      <tr [ngClass]="{'error': entry.error}">
        <td>{{ entry.key }}</td>
        <td *ngIf="!entry.children">{{ entry.content }}</td>
        <td *ngIf="entry.children" [innerHTML]="entry.content"></td>
      </tr>
    </ng-container>
  </table>
</div>
